import { types } from "../Actions/types";

const initialState = {
  exerciseCategorylist: [],
  error: null,
  exerciseCategorySingle: "",
  popupmodel: "",
};

const ExerciseCategory = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.EXERCISE_CATEGORY_LIST:
      return {
        ...state,
        exerciseCategorylist: payload,
        error,
      };
    case types.EXERCISE_CATEGORY_SINGLE:
      return {
        ...state,
        exerciseCategorySingle: payload,
        error,
      };
    case types.EXERCISE_CATEGORY_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default ExerciseCategory;
